import { useTranslation } from 'react-i18next'

import styles from './TestSiteBanner.module.scss'

export const TestSiteBanner = () => {
  const { t } = useTranslation('common')
  return <div className={styles.banner}>{t('test_banner')}</div>
}
